<template>
  <el-header height="90" class="header between">
    <div class="center-just" style="margin-top: 10px;">
      <el-image
        :src="$domain + 'static/noten/website/newHome/logo.png'"
        class="image"
      ></el-image>
      <div
        style="margin-top: 20px;margin-left: 30px;font-size: 18px;font-weight: 500;font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;"
      >
        开启未来之窗 点亮无限可能
      </div>
      <div class="btn" @click="open" style="cursor:pointer;">
        点击了解详情
      </div>
    </div>
    <!-- <div class="space"> -->
    <!-- <div class="home column-between" @click="gotoHome">
        <div class="text">首页</div>
        <div :class="active == 1 ? 'active' : ''"></div>
      </div>
      <div class="home column-between" @click="gotoVideoCourse">
        <div class="text">编程视频课</div>
        <div :class="active == 2 ? 'active' : ''"></div>
      </div>
      <div class="home column-between" @click="gotoCreation">
        <div class="text">创作中心</div>
        <div :class="active == 3 ? 'active' : ''"></div>
      </div>
      <div class="home column-between" @click="gotoMessage">
        <div class="text">动态资讯</div>
        <div :class="active == 4 ? 'active' : ''"></div>
      </div>
      <div class="home column-between" @click="gotoLogin">
        <div class="text1">登录/注册?</div>
        <div :class="active == 5 ? 'active' : ''"></div>
      </div> -->
    <!-- </div> -->
    <el-dialog
      title="一键获取授权资料及项目报价"
      :visible.sync="dialogVisible"
      width="50%"
      center
      round
      :modal="false"
    >
      <div class="mobile">
        <div class="info">
          <div class="item row">
            <div class="names" style="caret-color: transparent;">
              称&nbsp;呼<span style="color: red;">&nbsp;*</span> :
            </div>
            <input
              type="text"
              class="input"
              v-model="name"
              placeholder="请输入您的称呼"
            />
          </div>
          <div class="item row">
            <div class="names1" style="caret-color: transparent;">
              电&nbsp;话<span style="color: red;">&nbsp;*</span> :
            </div>
            <input
              type="tel"
              class="input"
              maxlength="11"
              required
              v-model="phone"
              placeholder="请输入您的手机号"
            />
          </div>
        </div>
        <div class="btns center-just" @click="submit1">
          立即下载
        </div>
      </div>
    </el-dialog>
  </el-header>
</template>

<script>
import router from "@/router";
import axios from "axios";
import api from "@/api";
import { userPortList } from "@/api/port";
export default {
  name: "Home",
  data() {
    return {
      active: 1,
      dialogVisible: false,
      newCityData: "",
      province: "北京市",
      city: "北京市",
      name: "",
      phone: "",
      dialogVisible: false
    };
  },
  methods: {
    submit() {
      if (this.name) {
        if (this.isValidChinesePhoneNumber()) {
          let params = {
            name: this.name,
            mobile: this.phone,
            province: this.province,
            city: this.city,
            channel: "官网下载资料"
          };
          this.dialogVisible = false;
          api
            .post(userPortList.postInfo, params)
            .then(res => {
              console.log(res.data);
              this.download(
                "https://static.smallschoolbag.com/static/ciyuankoudai/noten/image/pc/课程体系介绍.pdf",
                "次元口袋课程体系介绍"
              );
              this.count += 1;

              this.name = "";
              this.phone = "";
              this.province = "北京市";
              this.city = "北京市";
            })
            .catch(error => {
              // 捕获异常并处理
              console.error("Error:", error);
            });
        } else {
          this.$message({
            message: "请输入正确的手机号，以便我们能够联系到您！",
            type: "error",
            duration: 5000
          });
        }
      } else {
        this.$message({
          message: "请输入您的称呼，方便之后与您沟通！",
          type: "warning",
          duration: 5000
        });
      }
    },
    isValidChinesePhoneNumber(number) {
      const mobileRegExp = /^1[3456789]\d{9}$/;
      const landlineRegExp = /^0\d{2,3}-?\d{7,8}$/;
      return mobileRegExp.test(this.phone) || landlineRegExp.test(this.phone);
    },
    submit1() {
      if (this.name) {
        if (this.isValidChinesePhoneNumber()) {
          let params = {
            name: this.name,
            mobile: this.phone,
            province: this.province,
            city: this.city,
            channel: "官网下载资料"
          };
          api
            .post(userPortList.postInfo, params)
            .then(res => {
              console.log(res.data);
              this.dialogVisible = false;
              this.download(
                "https://static.smallschoolbag.com/static/ciyuankoudai/noten/image/pc/课程体系介绍.pdf",
                "次元口袋课程体系介绍"
              );

              this.count += 1;
              this.name = "";
              this.phone = "";
              this.province = "北京市";
              this.city = "北京市";
            })
            .catch(error => {
              // 捕获异常并处理
              console.error("Error:", error);
            });
        } else {
          this.$message({
            message: "请输入正确的手机号，以便我们能够联系到您！",
            type: "error",
            duration: 5000
          });
        }
      } else {
        this.$message({
          message: "请输入您的称呼，方便之后与您沟通！",
          type: "warning",
          duration: 5000
        });
      }
    },
    open() {
      this.dialogVisible = true;
    },
    async download(filename, name) {
      filename =
        "https://static.smallschoolbag.com/static/ciyuankoudai/noten/image/pc/课程体系介绍.pdf";
      name = "次元口袋课程体系介绍";
      try {
        const response = await axios.get(filename, {
          responseType: "blob"
        });

        const blob = new Blob([response.data]);
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        let extend = filename.split("/").pop();

        if (extend) {
          let lastIndex = extend.lastIndexOf(".");
          const extension = extend.substring(lastIndex + 1);
          if (name) {
            link.download = name + "." + extension;
          } else {
            link.download = extend;
          }
          link.click();
        }
      } catch (error) {
        console.error("Error downloading file:", error);
        // Handle error
      }
    },
    gotoHome() {
      this.active = 1;
      this.$router.push("/");
    },
    gotoVideoCourse() {
      this.active = 2;
      this.$router.push("/videoCourse");
    },
    gotoCreation() {
      this.active = 3;
      this.$router.push("/creation");
    },
    gotoMessage() {
      this.active = 4;
      this.$router.push("/message");
    },
    gotoLogin() {
      this.active = 5;
      this.$router.push("/login");
    }
  },
  onLoad() {
    console.log("进入首页");
  }
};
</script>

<style lang="scss" scoped>
@import "@/css/_functions.scss";
.mobile {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  .btns {
    // background-image: url(http://static.smallschoolbag.com/static/noten/website/home/index1_box6_btn.png);
    // background-size: 100% 100%;
    background-color: #3675f1;
    width: getWidth(200);
    height: getHeight(60);
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 500;
    letter-spacing: 1px;
    color: #ffffff;
    line-height: getHeight(37);
    cursor: pointer;
    border-radius: 10px;
    margin-top: 20px;
  }
  .info {
    display: flex;
    flex-direction: row;
    margin-top: getHeight(10);

    .item {
      width: 300px;
      height: getHeight(60);
      background: #f5f7ff;
      border: 1px solid #b2c2ff;
      border-radius: get2Px(20);
      display: flex;
      align-items: center;
      justify-content: center;
      // margin-top: getHeight(20);
      margin-left: getWidth(20);

      // margin-left: getWidth(45);
      .selects {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        background-image: url("http://static.smallschoolbag.com/static/noten/website/home/index1_box6_dropdownbtn.png");
        background-repeat: no-repeat;
        background-position: center right;
        // padding-right: getWidth(10);
        height: getHeight(40);
        width: getWidth(600);
        border: none;
        outline: none;
        background-color: #f5f7ff;
        font-size: 14px;
        color: #1966ff;
        cursor: pointer;
      }
      .names {
        width: 60px;
        line-height: getHeight(37);
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #1966ff;
      }
      .names1 {
        width: 60px;
        line-height: 37px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #1966ff;
      }
      .input {
        width: getWidth(360);
        height: getHeight(50);
        border: none !important;
        outline-color: invert;
        outline-style: none;
        outline-width: 0px;
        border: none;
        border-style: none;
        text-shadow: none;
        -webkit-appearance: none;
        -webkit-user-select: text;
        outline-color: transparent;
        box-shadow: none;
        background: #f5f7ff;
        // font-weight: bold;
        color: #1a1a1a;
        font-size: 14px;
      }
      ::-webkit-input-placeholder {
        color: rgb(190, 187, 187);
      }
    }
  }
}
.outer {
  height: getHeight(300);
  width: getWidth(483);
  // background-color: antiquewhite;
  display: flex;
  justify-content: center;
  .outer-content {
    // background-color: red;
    // width: 80%;
    // height: 62%;
    // margin-top: 50px;
    // display: flex;
    // flex-wrap: wrap;
    .title {
      display: flex;
      align-self: center;
      color: #585656;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 500;
      // color: #1dc2ff;
      line-height: getHeight(37);
      // margin-top: getHeight(100);
      // margin-bottom: getHeight(20);
    }
    .subtitle {
      display: flex;
      justify-content: center;
      justify-items: center;
      color: #a7a1a1;
      font-size: 14px;
      margin-top: 10px;
    }

    .btn {
      // background-image: url(http://static.smallschoolbag.com/static/noten/website/home/index1_box6_btn.png);
      // background-size: 100% 100%;
      background-color: #3675f1;
      width: getWidth(400);
      height: getHeight(60);
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 500;
      letter-spacing: 1px;
      color: #ffffff;
      line-height: getHeight(37);
      cursor: pointer;
      border-radius: 10px;
      // margin-top: 20px;
    }
  }
}
.btn {
  background: #68bfec;
  color: #ffffff;
  font-size: 14px;
  letter-spacing: 1px;
  height: 30px;
  width: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  margin-left: 500px;
}
.header {
  height: 90px;
  width: 64.5%;
  display: flex;

  .round {
    width: 36px;
    height: 36px;
    background: #1dc2ff;
    border-radius: 50%;
  }
  .space {
    margin-top: 35px;
    width: 62%;
    .home {
      height: 40px;
      cursor: pointer;
      .text {
        // line-height: 20px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        caret-color: transparent;
      }
      .text1 {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #1dc2ff;
      }
      .active {
        width: 26px;
        height: 8px;
        background: #1dc2ff;
        border-radius: 4px;
        align-self: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue